
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Onewaytaximumbaitopune() {



    const cardData =
    {
        keyword: ' One Way Taxi Mumbai to Pune',
        heading: 'Skyline Cabs: One Way Taxi Mumbai to Pune',
        headingDescription: 'Skyline Cabs offers affordable and convenient One Way Taxi from Mumbai to Pune for a smooth and budget-friendly intercity travel experience. Whether you are heading to Pune for business, leisure, or personal reasons, our clean, well-maintained vehicles and professional drivers ensure a safe and comfortable journey. Enjoy timely pickups from any location in Mumbai, transparent one-way fares, and 24/7 customer support. Book your Mumbai to Pune one way taxi today with Skyline Cabs and travel hassle-free at the best rates.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pune Cab",
      "description": "Skyline Cabs provides reliable and affordable taxi services from Mumbai to Pune. Whether you need a one-way trip or round trip, we offer a variety of vehicles including sedans, SUVs, and luxury cars to ensure your journey is comfortable."
    },
    {
      "name": "Mumbai Airport to Pune Cab",
      "description": "For a smooth and timely journey from Mumbai Airport to Pune, Skyline Cabs offers comfortable cabs. Book your ride online or at the airport and travel in comfort with our well-maintained vehicles."
    },
    {
      "name": "Mumbai to Pune Taxi",
      "description": "Book a taxi from Mumbai to Pune with Skyline Cabs. Our professional drivers ensure a hassle-free trip, with transparent pricing and timely arrivals. Choose from a variety of vehicles to match your needs."
    },
    {
      "name": "Mumbai to Pune Cab Price",
      "description": "Skyline Cabs offers competitive pricing for trips from Mumbai to Pune. The fare depends on the vehicle type, distance, and other factors, with no hidden charges. Our pricing is designed to ensure the best value for your journey."
    },
    {
      "name": "Mumbai to Pune Cab Service",
      "description": "Skyline Cabs provides a top-notch cab service from Mumbai to Pune. Whether you are traveling for business or leisure, our cabs are clean, comfortable, and driven by professional chauffeurs to ensure a smooth journey."
    },
    {
      "name": "Mumbai to Pune Taxi Price",
      "description": "Skyline Cabs offers affordable taxi pricing from Mumbai to Pune. We ensure transparent rates with no hidden charges, ensuring a hassle-free booking and ride experience."
    },
    {
      "name": "Mumbai Pune Car Rental",
      "description": "Skyline Cabs offers a convenient car rental service from Mumbai to Pune. Choose from a wide selection of vehicles, including economy, luxury, and SUVs, with the flexibility of self-drive or chauffeur-driven options."
    },
    {
      "name": "Mumbai Pune Cab One Way",
      "description": "Looking for a one-way cab from Mumbai to Pune? Skyline Cabs offers one-way services at affordable rates with no additional charges for a simple, one-way journey."
    },
    {
      "name": "Mumbai to Pune Cab from Airport",
      "description": "If you are arriving at Mumbai Airport, Skyline Cabs offers a seamless transfer service to Pune. Book your cab in advance and travel with ease from the airport to your destination."
    },
    {
      "name": "Pune to Mumbai Taxi One Way",
      "description": "Skyline Cabs also offers one-way taxi services from Pune to Mumbai. Our fleet includes comfortable vehicles like Innova Crysta and Ertiga to ensure a smooth ride at great rates."
    },
    {
      "name": "Cab for Mumbai to Pune",
      "description": "Book a cab for your Mumbai to Pune journey with Skyline Cabs. Choose from a variety of vehicles, from economy cars to luxury options, to ensure a pleasant and comfortable ride."
    },
    {
      "name": "Cab Service Mumbai to Pune",
      "description": "Skyline Cabs offers efficient and reliable cab services from Mumbai to Pune. We provide well-maintained vehicles and professional drivers to make your journey safe and enjoyable."
    },
    {
      "name": "Mumbai Pune Cab Fare",
      "description": "Skyline Cabs offers transparent and competitive fares for your Mumbai to Pune taxi ride. The fare is based on the vehicle type and route, with no hidden charges, so you can book with confidence."
    },
    {
      "name": "Mumbai International Airport to Pune Cab",
      "description": "Skyline Cabs provides easy and comfortable transfers from Mumbai International Airport to Pune. Book your cab online or at the airport and enjoy a seamless journey with our reliable drivers."
    },
    {
      "name": "Cab Booking Mumbai to Pune",
      "description": "Book your Mumbai to Pune cab with Skyline Cabs online. Our simple booking process, competitive pricing, and fleet of vehicles make it easy for you to secure a ride that meets your travel needs."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Cab", "Mumbai Airport to Pune Cab"],
    ["Mumbai to Pune Taxi", "Mumbai to Pune Cab Price"],
    ["Mumbai to Pune Cab Service", "Mumbai to Pune Taxi Price"],
    ["Mumbai Pune Car Rental", "Mumbai Pune Cab One Way"],
    ["Mumbai to Pune Cab from Airport", "Pune to Mumbai Taxi One Way"],
    ["Cab for Mumbai to Pune", "Cab Service Mumbai to Pune"],
    ["Mumbai Pune Cab Fare", "Mumbai International Airport to Pune Cab"],
    ["Cab Booking Mumbai to Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Pune One Way Taxi Service",
        "WhyChoosedescription": "Our one-way taxi service from Mumbai to Pune ensures a safe, smooth, and punctual journey. Whether you are traveling for business or leisure, we guarantee timely arrivals with comfort."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Choose from a range of well-maintained vehicles including sedans, SUVs, and luxury cars. All our vehicles are air-conditioned, providing you a comfortable ride from Mumbai to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-versed with the best routes from Mumbai to Pune. They prioritize your comfort, safety, and punctuality, ensuring you a stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable One-Way Pricing",
        "WhyChoosedescription": "We offer competitive pricing for our one-way taxi service from Mumbai to Pune, ensuring no hidden costs. You’ll get the best value for money with our transparent and upfront pricing."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Our one-way taxi service is available round the clock. Whether you need to travel in the early morning or late at night, we ensure that you can book a ride at any time convenient for you."
    },
    {
        "WhyChooseheading": "Easy Online Booking & Instant Confirmation",
        "WhyChoosedescription": "Booking a taxi from Mumbai to Pune is simple with our user-friendly website or mobile app. Receive instant booking confirmation and enjoy real-time ride tracking."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "All our vehicles are thoroughly sanitized before each trip. Our drivers adhere to all safety measures, ensuring that your health and safety are our top priority during your one-way journey."
    },
    {
        "WhyChooseheading": "Comfortable Journey with Minimal Stops",
        "WhyChoosedescription": "We ensure a smooth and uninterrupted ride from Mumbai to Pune. With minimal stops, you can relax and enjoy your journey without delays."
    }
]






















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a one-way taxi from Mumbai to Pune with Skyline Cabs?',
            answer:
                'Booking a one-way taxi from Mumbai to Pune is quick and easy. You can book through our website, mobile app, or by calling our customer support team. Simply provide your pickup and drop-off details, choose your vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for a one-way taxi from Mumbai to Pune?',
            answer:
                'We offer a range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Select the vehicle based on your comfort preferences, group size, and budget.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Mumbai to Pune in a one-way taxi?',
            answer:
                'The travel time from Mumbai to Pune typically takes about 3.5 to 5 hours, depending on traffic and road conditions. Our professional drivers ensure the most efficient and smooth journey possible.',
        },
        {
            id: 4,
            question: 'Are the fares for a one-way taxi from Mumbai to Pune fixed?',
            answer:
                'Yes, we offer fixed fares for a one-way taxi from Mumbai to Pune. The price includes tolls, taxes, and driver charges, ensuring transparency with no hidden fees.',
        },
        {
            id: 5,
            question: 'Can I modify or cancel my one-way taxi booking from Mumbai to Pune?',
            answer:
                'Yes, you can easily modify or cancel your booking through our website, app, or by contacting our customer support team. We offer flexible options to accommodate your schedule.',
        },
        {
            id: 6,
            question: 'Are the taxis for Mumbai to Pune well-maintained and safe?',
            answer:
                'Yes, all our vehicles are regularly serviced, cleaned, and maintained to ensure a safe, comfortable, and worry-free journey. We prioritize your safety and satisfaction during the ride.',
        },
        {
            id: 7,
            question: 'What payment methods are available for a one-way taxi from Mumbai to Pune?',
            answer:
                'You can pay securely through UPI, credit/debit cards, net banking, or in cash at the end of the ride. Our online payment system is safe and convenient.',
        },
        {
            id: 8,
            question: 'Is the one-way taxi service available for corporate travel from Mumbai to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services. Whether it’s a business meeting, conference, or group travel, we provide tailored solutions to meet your corporate needs.',
        },
        {
            id: 9,
            question: 'Why should I choose Skyline Cabs for my one-way taxi from Mumbai to Pune?',
            answer:
                'Skyline Cabs offers a smooth, comfortable, and hassle-free experience for your one-way taxi from Mumbai to Pune. With professional drivers, well-maintained vehicles, fixed pricing, and excellent customer service, we ensure you reach your destination safely and on time.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked a one-way taxi from Mumbai to Pune with Skyline Cabs. The entire experience was fantastic! The driver was courteous, the car was clean and comfortable, and I reached Pune on time."
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Good experience with Skyline Cabs for my one-way trip from Mumbai to Pune. The car was nice, but the AC could’ve been a bit cooler. Overall, a smooth ride, and I would recommend them."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Taxi Mumbai to Pune",
  "image": "https://skylinecabs.com/assets/images/one-way-taxi-mumbai-to-pune.jpg",
  "description": "Book One Way Taxi from Mumbai to Pune with Skyline Cabs for a comfortable, affordable, and safe ride. Choose from AC sedans, SUVs, or premium cars — available 24/7 with professional drivers at fixed prices.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8264"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/one-way-taxi-mumbai-to-pune"
  }
};


      



    return (
        <div>
<Helmet>
  <title>One Way Taxi Mumbai to Pune | 24/7 AC Cab Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book One Way Taxi from Mumbai to Pune with Skyline Cabs for a comfortable, affordable, and safe ride. Choose from AC sedans, SUVs, or premium cars — available 24/7 with professional drivers at fixed prices." 
  />
  <meta 
    name="keywords" 
    content="One Way Taxi Mumbai to Pune, Mumbai to Pune One Way Cab, AC Cab Mumbai to Pune, SUV Taxi Mumbai to Pune, Skyline Cabs Mumbai Pune, Affordable Taxi Mumbai to Pune, 24/7 Cab Mumbai to Pune, Online Cab Booking Mumbai to Pune, Sedan Taxi Mumbai to Pune, Premium Taxi Mumbai Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/73.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onewaytaximumbaitopune;